export default __webpack_public_path__ + "static/media/herocar.7df1b35d.png";